import { styled } from "@mui/material";
import { theme } from "@sinch/core/config/theme";
import { hasNotProp } from "@sinch/utils/object";
import type { TimeBarHorizontalAxisProps } from "@sinch/components/TimeBarGraph/TimeBarHorizontalAxis";

export const RateBuilderBottomToolbar = styled("div", {
  shouldForwardProp: hasNotProp<TimeBarHorizontalAxisProps>(["elseToolbar", "isWrapped", "shorten", "loading"]),
})<{ isWrapped?: boolean; elseToolbar?: boolean; shorten?: boolean; loading?: boolean }>(
  ({ isWrapped, elseToolbar, shorten, loading }) => ({
    display: "flex",
    alignItems: "center",
    minHeight: "30px",
    ...(!!elseToolbar && { marginLeft: theme.spacing(-2), paddingLeft: theme.spacing(2) }),
    ...(!elseToolbar && { marginLeft: shorten ? `var(--short-indentation-offset)` : "var(--level-identation-offset)" }),
    position: "relative",
    ...(loading && { animation: "1s ease-in-out 0.5s infinite normal none bottomToolbarPulsing" }),
    "&::before": isWrapped && {
      content: "' '",
      display: "block",
      position: "absolute",
      borderLeft: "var(--tree-lines-width, 2px) solid var(--if-else-lines-color)",
      top: 0,
      bottom: 0,
      left: `calc( var(--if-else-line-offset) * -1 - ${shorten ? `var(--short-indentation-offset)` : "var(--level-identation-offset)"})`, //theme.spacing(-1.5),
    },
    "&::after": {
      content: '" "',
      position: "absolute",
      display: "block",
      transform: "scale(1, 0.5) translate(0, -50%)",
      top: 0,
      bottom: 0,
      ...(!!elseToolbar && {
        borderLeft: "var(--tree-lines-width, 2px) solid var(--if-else-lines-color)",
        borderBottom: "calc(var(--tree-lines-width, 2px) * 2) solid var(--if-else-lines-color)",
        left: "calc(16px - var(--if-else-line-offset))",
        width: shorten ? "var(--short-line-offset)" : `var(--if-else-line-offset)`,
      }),
      ...(!elseToolbar && {
        borderLeft: "var(--tree-lines-width, 2px) solid var(--lines-color)",
        borderBottom: "calc(var(--tree-lines-width, 2px) * 2) solid var(--lines-color)",
        width: shorten ? "var(--short-line-offset)" : `var(--main-line-offset)`,
        left: `calc(-1 * ${shorten ? `var(--short-indentation-offset) + 25px` : "var(--main-line-offset)"} - var(--tree-lines-width, 2px) / 2)`,
      }),
    },
    "@keyframes bottomToolbarPulsing": {
      "0%": {
        opacity: 1,
      },
      "50%": {
        opacity: 0.4,
      },
      "100%": {
        opacity: 1,
      },
    },
  })
);
